import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
/**
 * This is just a customization of [react-helmet](https://www.npmjs.com/package/react-helmet) to allow passing
 * metadata using an object instead of manually writing all the HTML.
 */
export var CustomHelmet = function (_a) {
    var title = _a.title, description = _a.description, properties = _a.properties;
    return (_jsxs(Helmet, { children: [title && _jsx("title", { children: title }), description && _jsx("meta", { name: "description", content: description }), properties &&
                Object.entries(properties).map(function (_a) {
                    var propertyKey = _a[0], propertyValue = _a[1];
                    return (_jsx("meta", { property: propertyKey, content: propertyValue }, propertyKey));
                })] }));
};
